import {
  BookOpen,
  CalendarCheck,
  FileText,
  GraduationCap,
  Video,
} from "lucide-react";

/** Single shell-owned catalog for student route paths, labels, subtitles, and module tones. */
export const STUDENT_NAVIGATION = [
  {
    id: "liveClasses",
    segment: "live-classes",
    path: "/student/live-classes",
    subtitle: "کلاس‌های آنلاین",
    lazy: () => import("@/features/student-portal/route"),
    title: "کلاس آنلاین",
    icon: Video,
    activeColor: "text-module-sky-600",
    activeBg: "bg-module-sky-100",
    activeBorder: "border-module-sky-200",
  },
  {
    id: "attendance",
    segment: "attendance",
    path: "/student/attendance",
    subtitle: "وضعیت حضور و تردد امروز",
    lazy: async () => ({
      Component: (await import("@/features/student-portal"))
        .StudentAttendancePage,
    }),
    title: "حضور و غیاب",
    icon: CalendarCheck,
    activeColor: "text-module-emerald-600",
    activeBg: "bg-module-emerald-100",
    activeBorder: "border-module-emerald-200",
  },
  {
    id: "courses",
    segment: "courses",
    path: "/student/courses",
    subtitle: "دروس و برنامه هفتگی",
    lazy: async () => ({
      Component: (await import("@/features/student-portal")).StudentCoursesPage,
    }),
    title: "دروس",
    icon: BookOpen,
    activeColor: "text-module-violet-600",
    activeBg: "bg-module-violet-100",
    activeBorder: "border-module-violet-200",
  },
  {
    id: "homework",
    segment: "homework",
    path: "/student/homework",
    subtitle: "تکالیف و تمرین‌ها",
    lazy: async () => ({
      Component: (await import("@/features/student-portal"))
        .StudentHomeworkPage,
    }),
    title: "تکالیف",
    icon: FileText,
    activeColor: "text-module-amber-600",
    activeBg: "bg-module-amber-100",
    activeBorder: "border-module-amber-200",
  },
  {
    id: "scores",
    segment: "scores",
    path: "/student/scores",
    subtitle: "کارنامه و نمرات",
    lazy: async () => ({
      Component: (await import("@/features/student-portal")).StudentScoresPage,
    }),
    title: "نمرات",
    icon: GraduationCap,
    activeColor: "text-module-emerald-600",
    activeBg: "bg-module-emerald-100",
    activeBorder: "border-module-emerald-200",
  },
] as const;
